<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.74 59.74">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_4" data-name="Layer 4">
                <g>
                    <path
                        d="M25.5,13.8a4.72,4.72,0,0,0-6.69,0l-5,5a4.72,4.72,0,0,0,0,6.69L35.63,47.33h11.7V35.63ZM14.94,24.36a3.13,3.13,0,0,1,0-4.41l5-5a3.13,3.13,0,0,1,4.41,0l1.52,1.53-9.41,9.41ZM17.62,27,27,17.62,45.37,36,36,45.37ZM45.71,45.71H37.93l7.78-7.78Z"
                        fill="#fff"
                    />
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
export default {};
</script>



// WEBPACK FOOTER //
// EditIcon.vue?5b8b874e